import { Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { parseIso8601, Store, toIsoDate } from '@softline/core';
import { SOFTLINE_PERMISSION_TIMESTAMP_SELECT_EMPLOYEE } from '../../stempelerfassung.permissions';
import {
  BackNavigable,
  BackNavigationService,
  SOFTLINE_FEATURE_TITLE,
  TitleStore } from '@softline/application';
import { of } from 'rxjs';
import { TimestampQuery } from '../../data/timestamp.query';
import {
  SOFTLINE_FEATURE_TIMESTAMP,
  SOFTLINE_FEATURE_TIMESTAMP_EMPLOYEE,
  TimestampEmployeeStore,
  TimestampStore } from '../../stempelerfassung.shared';
import { authorizationFn } from '@softline/auth';
import { CommonModule } from '@angular/common';

import { DateInputComponent } from '@softline/ui-core/date-input';
import { TranslatePipe } from '@softline/ui-core';
@Component({
    // tslint:disable-next-line:component-selector
    selector: 'soft-timestamp-query',
    templateUrl: './query.component.html',
    styleUrls: ['./query.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, ReactiveFormsModule,
    DateInputComponent,
    TranslatePipe]
})
export class QueryComponent implements OnInit, OnDestroy, BackNavigable {
  private readonly store = inject(Store);
  protected readonly router = inject(Router);
  private readonly backNavigationService = inject(BackNavigationService);
  private readonly isAuthorized = authorizationFn();

  title$ = of('#TIMESTAMP.TITLE_QUERY');

  form = new UntypedFormGroup({
    employee: new UntypedFormControl(),
    from: new UntypedFormControl(),
    to: new UntypedFormControl() });

  readonly canModifyEmployee = this.isAuthorized(SOFTLINE_PERMISSION_TIMESTAMP_SELECT_EMPLOYEE);

  async ngOnInit(): Promise<void> {
    this.store.commit(
      SOFTLINE_FEATURE_TITLE,
      TitleStore.mutations.setSubTitle,
      '#TIMESTAMP.TITLE_QUERY'
    );
    this.backNavigationService.set(this);
    const query = this.store.get(
      SOFTLINE_FEATURE_TIMESTAMP,
      TimestampStore.getters.query.query
    );
    if (query) this.form.patchValue({ from: query?.from, to: query?.to });

    const employees = await this.store.dispatch(
      SOFTLINE_FEATURE_TIMESTAMP_EMPLOYEE,
      TimestampEmployeeStore.actions.loadMany
    );
    this.form.patchValue({ employee: employees[0] });
  }

  ngOnDestroy(): void {
    this.store.commit(
      SOFTLINE_FEATURE_TITLE,
      TitleStore.mutations.setSubTitle,
      ''
    );
    this.backNavigationService.set(undefined);
  }

  async navigateBack(): Promise<void> {
    await this.router.navigate(['/stempelerfassung']);
  }

  async onSubmit(value: any): Promise<void> {
    const params: TimestampQuery = {
      employeeid: value.employee.id,
      from: toIsoDate(new Date(parseIso8601(value.from) ?? NaN)),
      to: toIsoDate(new Date(parseIso8601(value.to) ?? NaN)) };
    await this.router.navigate(['stempelerfassung', 'query', 'result'], {
      queryParams: params });
  }
}
